import * as React from "react";

import { WorkspaceSidebarContext } from "./context";
import { WorkspaceSidebarStorage } from "./sidebarStorage";
import { SidebarTab, SidebarView, SidebarViewType } from "./sidebarView";

export function WorkspaceSidebarProvider({
  children,
}: React.PropsWithChildren) {
  // Reopening a workspace in the same tab restores the last sidebar view type
  // and tab (persisted by the effect below); view data always starts unset.
  const [activeView, setActiveView] = React.useState<SidebarView<unknown>>(
    () => {
      const stored = WorkspaceSidebarStorage.getActiveView();
      return {
        type: stored?.type ?? SidebarViewType.TabbedSidebar,
        data: undefined,
      };
    },
  );

  const [activeDrawer, setActiveDrawer] =
    React.useState<SidebarView<unknown> | null>(null);

  const [activeTab, setActiveTab] = React.useState<SidebarTab>(() => {
    const stored = WorkspaceSidebarStorage.getActiveView();
    return stored?.tab ?? SidebarTab.Files;
  });

  const close = () => {
    setActiveView({
      type: SidebarViewType.None,
      data: undefined,
    });
  };

  React.useEffect(() => {
    // setActiveView only records the tab for TabbedSidebar views.
    WorkspaceSidebarStorage.setActiveView(activeView.type, activeTab);
  }, [activeView.type, activeTab]);

  return (
    <WorkspaceSidebarContext.Provider
      value={{
        activeView,
        activeDrawer,
        close,
        openView: setActiveView,
        toggleDrawer: setActiveDrawer,
        activeTab: activeTab,
        setActiveTab: setActiveTab,
      }}
    >
      {children}
    </WorkspaceSidebarContext.Provider>
  );
}
